export const environment = {
  production: false,
  awsPlacesApiKey:
    "v1.public.eyJqdGkiOiIyNzVmMTY5NC0zMzE0LTQ0ZDYtOTk2ZS1iYTNlYWFmNDljNzgifQQwKW7xz9KPeJoSqyX3A7atNVuL4gFAlxvfG_RKKB5D2dGYJRPvMCG0bDdprelLKbCPFvfPclxAER5klZkdnEWVEaGWFMrUwbSoKHt1lKYoDTd8Pyweh-LBmrubfnBxY-9ZvtwNtnv2ln03LKHsFN65Fkf5w7ThdibOv8YxX-YppHT7vI9-DwqjVJrrAXimyTl-Y58ZKlhWCvwZam4B9ih3HU7p-gzvkYcgBNTdemXe8C7QehfgGAmRZyVQSfsbH5YwYVQO237aLhKFd08cjNuQKZMKCBn-nJ-lo9pPPlbLol3EHBhfwfFTb1OILSFaPY-6IVhTx78nh8JRSmRMiGE.ZWU0ZWIzMTktMWRhNi00Mzg0LTllMzYtNzlmMDU3MjRmYTkx", // Replace with your actual API key
  authApiUrl: "https://authapi-dev.graftsoftware.com/api",
  // authApiUrl: "http://localhost:3002/api",
  contentApiUrl: "https://contentapi-dev.graftsoftware.com/api",
  // contentApiUrl: "http://localhost:3003/api",
  epicApiUrl: "https://epicapi-dev.graftsoftware.com/api",
  notesApiUrl: "https://notesapi-dev.graftsoftware.com/api",
  // notesApiUrl: "http://localhost:3004/api",
  notificationsApiUrl: "https://notificationsapi-dev.graftsoftware.com/api",
  // notificationsApiUrl: "http://localhost:3005/api",
  questionnaireApiUrl: "https://questionsapi-dev.graftsoftware.com/api",
  // questionnaireApiUrl: "http://localhost:3000/api",
  userManagementApiUrl: "https://usersapi-dev.graftsoftware.com/api",
  reportingApiUrl: "https://reportingapi-dev.graftsoftware.com/api",
  ineligibility_logic: {
    age: 18,
    bmi: {
      range: [0, 32.0] as [number, number],
      yellow_constant: 2 //30 yellow 20.5 yellow 
    },
    'Eligibility Status': 'Eligible'
  }
};
